import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';

const EventAttendanceIcon = ({ size = 22, color = 'currentColor', className }) => (
  <FontAwesomeIcon
    icon={faCalendarCheck}
    className={className}
    style={{ fontSize: size, color, width: '1em', height: '1em' }}
  />
);

export default EventAttendanceIcon;
